export default "__VITE_ASSET__LFmPHVvu__"